
// Import vendor modules.
import { Controller } from "@hotwired/stimulus";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

export class EmojisController extends Controller {

	/**
	* I emit the "emoji" event for the emoji defined by the given button.
	*/
	emitEmoji( event ) {

		var emoji = this.extractEmojiFromTarget( event.target );

		this.dispatch(
			"emoji",
			{
				detail: {
					emoji: emoji
				}
			}
		);

	}

	// ---
	// PRIVATE METHODS.
	// ---

	/**
	* I extract the emoji glyph from the given button target.
	*/
	extractEmojiFromTarget( target ) {

		var codepoints = target
			.dataset
			.hex
			.split( " " )
			.map(
				( hex ) => {

					return( parseInt( hex, 16 ) );

				}
			)
		;

		return( String.fromCodePoint( ...codepoints ) );

	}

}
